import React from "react";
import { Link } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export function SummaryCard({ label, value, icon: Icon, accent = "sky", testId, delay = 0, hint, to }) {
  const accents = {
    sky: "bg-sky-50 text-sky-600",
    emerald: "bg-emerald-50 text-emerald-600",
    red: "bg-red-50 text-red-600",
    violet: "bg-violet-50 text-violet-600",
    amber: "bg-amber-50 text-amber-600",
    rose: "bg-rose-50 text-rose-800",
    slate: "bg-slate-100 text-slate-700",
    lettering: "bg-violet-100 text-violet-700 ring-1 ring-violet-200",
    thespian: "bg-amber-100 text-amber-700 ring-1 ring-amber-200",
    shownotes: "bg-rose-100 text-rose-700 ring-1 ring-rose-200",
  };
  const card = (
    <Card
      data-testid={testId}
      className={cn(
        "p-5 border-slate-200 shadow-sm rounded-xl bg-white animate-fade-in-up hover:shadow-md transition-transform hover:-translate-y-0.5",
        to && "cursor-pointer h-full"
      )}
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <p className="text-xs font-bold uppercase tracking-wider text-slate-500">{label}</p>
          <p className="mt-2 text-3xl font-extrabold text-slate-900 font-heading tabular-nums">{value}</p>
          {hint && <p className="mt-1 text-xs font-semibold text-slate-500">{hint}</p>}
        </div>
        {Icon && (
          <span className={cn("flex h-11 w-11 shrink-0 items-center justify-center rounded-xl", accents[accent])}>
            <Icon className="h-5 w-5" />
          </span>
        )}
      </div>
    </Card>
  );
  if (to) return <Link to={to} className="block">{card}</Link>;
  return card;
}

export default SummaryCard;
